import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteBank, ApiGetBankList } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function BankService() {
    const { showFail } = useModal()

    const { fetch: apiGetBankList } = useFetch(ApiGetBankList)
    const { fetch: apiDeleteBank } = useFetch(ApiDeleteBank)
 
    const fetchBankList = async (bankCode, bankName, status, pageSize, pageIndex) => {
        const res = await apiGetBankList({
            data: {
                bankCode,
                bankName, 
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteBank = async (bankId, status) => {
        const res = await apiDeleteBank({
            data: { 
                bankId, 
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchBankList,
        fetchDeleteBank
    }
}